<template>
  <app-base
    :help-button="!!URLS.HELP_DESK_URL"
    show-image-finder
    show-setting-shell
  >
    <template #default="{ resetKey }">
      <agreement-modal
        ref="modalRef"
        :key="resetKey"
        v-bind="agreementProps"
        @update:model-value="setModelValue"
        @update:config="onUpdateConfig"
        @update:plan="setPlan"
        @tf:complete="onTypeFormComplete"
      />
    </template>
  </app-base>
</template>

<script setup>
import URLS from './urls'
import AppBase from '../common/AppBase'
import AgreementModal from '@/components/AgreementModal'
import { useAgreement } from '@/composables'
import { ref, watch } from 'vue'
import { useShellStore } from './../../store'
import { useRoute } from 'vue-router'
import { pinia } from './../../store/createPinia'

const modalRef = ref()
const {
  agreementProps,
  setModelValue,
  setPlan,
  onTypeFormComplete,
  onUpdateConfig
} = useAgreement(
  modalRef
)

const route = useRoute()
const shellStore = useShellStore(pinia)

function openModal (item) {
  shellStore.SET_SETTINGS_SHELL(true)
  shellStore.SET_SETTINGS_ITEM_ID(item)
}

if (route.query.settings) {
  openModal(route.query.settings)
}
watch(
  () => route.query.settings,
  (newSettingItem, oldSettingItem) => {
    if (newSettingItem && oldSettingItem !== newSettingItem) {
      openModal(newSettingItem)
    }
  }
)
</script>
